import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () =>
        import( /* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/alterar-senha',
      name: 'alterar-senha',
      component: () =>
        import( /* webpackChunkName: "alterar-senha" */ './views/AlterarSenha.vue')
    },
    { path: '*', redirect: '/' }
  ],
});
